
import { combineReducers } from 'redux';
import mainReducer from './reducers/main';
import questionnaireReducer from './reducers/questionnaire';

export default combineReducers({
    main: mainReducer,
    questionnaire: questionnaireReducer
});
